import { Component } from '@angular/core';

@Component({
  selector: 'ConciliacioBancaria-component',
  styles: [],
  templateUrl: 'conciliacioBancaria-component.html'
})

export class ConciliacioBancaria {}


// WEBPACK FOOTER //
// ./src/app/Contabilidad/conciliacionBancaria/conciliacioBancaria-component.ts